module.exports = __webpack_public_path__ + "img/gallery2.ba9aa2e.jpg";